import React from 'react';
import { Link } from 'react-router-dom';
import { FaStar } from 'react-icons/fa';

function ProductCard({ product }) {
  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <FaStar key={index} style={{ color: index < rating ? '#B87F5F' : '#E8E4DC' }} />
    ));
  };

  return (
    <div className="product-card">
      <div className="product-image-container">
        <img 
          src={product.image} 
          alt={product.name} 
          className="product-image"
        />
        <span className="product-badge">Premium</span>
      </div>
      <div className="product-info">
        <h3 className="product-name">{product.name}</h3>
        <p className="product-description">{product.shortDescription}</p>
        <div className="product-rating">
          <div className="stars">
            {renderStars(product.rating)}
          </div>
          <span className="rating-text">({product.reviews} reviews)</span>
        </div>
        <div className="product-footer">
          <span className="product-price">AU${product.price}</span>
          <Link to={`/product/${product.id}`} className="view-details-btn">
            View Details
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;